import { nanoid } from 'nanoid';
import { SocketIOConfig } from '@multiplayer-app/ai-agent-types';

const GUEST_USER_ID_KEY = 'mp-agents-guest-user-id';

/**
 * Get or generate a unique guest user ID.
 * The ID is persisted in localStorage so it remains consistent across sessions.
 */
export function getGuestUserId(): string {
  if (typeof window === 'undefined') {
    // Server-side: return a new ID each time (shouldn't happen in practice)
    return `${SocketIOConfig.DefaultUserId}-${nanoid()}`;
  }

  // Check if we already have a guest ID stored
  const stored = localStorage.getItem(GUEST_USER_ID_KEY);
  if (stored) {
    return stored;
  }

  // Generate a new unique guest ID
  const guestId = `${SocketIOConfig.DefaultUserId}-${nanoid()}`;
  localStorage.setItem(GUEST_USER_ID_KEY, guestId);
  return guestId;
}
